import { Divider, message, Spin } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import ButtonItem from "../../../../../Components/ButtonItem";
import moment from "moment";
import 'moment/locale/es'

class DomicializacionConekta extends Component {

    formRef = React.createRef()

    state = {
        loading: false,
        pagoId: null,
        nombre: '',
        loadingConekta: false,
        estadoPago: 1,
        pago: false
    }

    componentDidMount() {

        // Make sure the Conekta script is loaded before initializing

        if (this.props.empresaId) {
            this.loadConektaScript();
        }
    }

    loadConektaScript(pagoId) {
        const script = document.createElement('script');
        script.src = 'https://pay.conekta.com/v1.0/js/conekta-checkout.min.js'; // Make sure the script URL is correct
        script.async = true;
        script.onload = () => this.initializeConektaCheckout(pagoId);
        document.body.appendChild(script);
    }

    initializeConektaCheckout() {
        const options = {
            backgroundMode: 'lightMode', // lightMode or darkMode
            colorPrimary: '#081133', // botones y bordes
            colorText: '#585987', // títulos
            colorLabel: '#585987', // input labels
            inputType: 'minimalMode', // minimalMode or flatMode
        };

        const config = {
            locale: 'es',
            publicKey: process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_CONEKTA_PUBLIC_KEY_DEV
                : process.env.REACT_APP_CONEKTA_PUBLIC_KEY_PROD, // Replace with your actual public key
            targetIFrame: '#conekta_domicializacion', // Make sure this ID matches the target container
        };

        const infoSuccessFunction = (loadingTime) => {
            this.setState({ loadingConekta: false })
        }

        const domiciliarEmpresa = (tokenId) => {
            this.setState({ loading: true, loadingConekta: true })
            axios
                .post(
                    "domicializacion/domiciliarEmpresa",
                    { empresaId: this.props.empresaId, tokenId },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false, loadingConekta: false })
                    if (res.data.success === 2) {
                        message.success(res.data.message ? res.data.message : "Se ha creado la domicializacion correctamente.");
                        this.cerrarDomicializacionConekta()
                    } else if (res.data.success === 1) {
                        message.warning(res.data.message);
                    } else {
                        message.error("No se domicializo correctamente");
                    }
                });
        }

        const callbacks = {
            onGetInfoSuccess: (loadingTime) => infoSuccessFunction(loadingTime),
            onCreateTokenSucceeded: (tokenId) => domiciliarEmpresa(tokenId),
            onCreateTokenError: function (error) {
                console.log('error en pago: ', error);
            },
        };

        window.ConektaCheckoutComponents.Card({
            config,
            callbacks,
            options
        });

    }

    cerrarDomicializacionConekta() {
        this.props.cerrarDomicializacionConekta()
    }

    render() {
        return (
            <Spin tip='Cargando pago...' spinning={this.state.loadingConekta}>
                <div id='conekta_domicializacion' style={{ height: '550px', padding: 0 }}>
                    {/* This will be the iframe or container for the Conekta checkout */}

                </div>
                <p style={{ color: '#333', marginBottom: '1em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>Pago</strong> El siguiente cobro se realizara {moment(this.props.fechaVencimiento).subtract(5, "days").isBefore(moment()) ? "al finalizar la domiciliación" : moment(this.props.fechaVencimiento).subtract(5, "days").fromNow()}</p>
                <p style={{ color: '#333', marginBottom: '1em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>Domicializacion</strong> Esto permitira pagar automaticamente el sistema mensualmente</p>
                <p style={{ color: '#333', marginBottom: '1em', marginLeft: '1em', fontSize: '.8rem' }}> <strong>Factura</strong> la factura se generara automaticamente con cada cargo</p>
                <Divider style={{ color: 'black', borderColor: 'black', marginBottom: '1em', marginTop: '1em' }} />
                <ButtonItem
                    type="primary"
                    danger
                    style={{ marginBottom: '2em' }}
                    onClick={this.cerrarDomicializacionConekta.bind(this)}
                >
                    Regresar
                </ButtonItem>
            </Spin>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        usuarioId: state.user.usuarioId,
    };
};

export default connect(mapStateToProps)(DomicializacionConekta);